import { render, staticRenderFns } from "./OnsiteWorkshop.vue?vue&type=template&id=71af7387&scoped=true&"
import script from "./OnsiteWorkshop.vue?vue&type=script&lang=js&"
export * from "./OnsiteWorkshop.vue?vue&type=script&lang=js&"
import style0 from "./OnsiteWorkshop.vue?vue&type=style&index=0&id=71af7387&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71af7387",
  null
  
)

export default component.exports